import React from "react";

import {
  EmailFileTypeIcon,
  FolderTypeIcon,
  FormTypeIcon,
  ImageTypeIcon,
  NoteTypeIcon,
  OtherTypeIcon,
  PDFTypeIcon,
  PptTypeIcon,
  SpreadsheetTypeIcon,
  TextTypeIcon
} from "assets/material-custom-icons";

import { EntityType, FileType } from "../../../constants";
import { ComponentsHashType } from "../../../store/types";

export const formFileIconsHash: ComponentsHashType<FileType | EntityType> = {
  [FileType.PDF]: PDFTypeIcon,
  [FileType.CSV]: SpreadsheetTypeIcon,
  [FileType.XLX]: SpreadsheetTypeIcon,
  [FileType.XLS]: SpreadsheetTypeIcon,
  [FileType.XLSX]: SpreadsheetTypeIcon,
  [FileType.DOCX]: TextTypeIcon,
  [FileType.TXT]: TextTypeIcon,
  [FileType.DOC]: TextTypeIcon,
  [FileType.PPT]: PptTypeIcon,
  [FileType.PPTX]: PptTypeIcon,
  [EntityType.FOLDER]: FolderTypeIcon,
  [EntityType.SECTION]: FolderTypeIcon,
  [EntityType.EMAIL]: EmailFileTypeIcon,
  [FileType.JPG]: ImageTypeIcon,
  [FileType.PNG]: ImageTypeIcon,
  [FileType.JPEG]: ImageTypeIcon,
  [FileType.FILE]: OtherTypeIcon,
  [EntityType.NOTE]: NoteTypeIcon,
  [EntityType.FORM]: FormTypeIcon,
  [EntityType.DOCUMENT]: TextTypeIcon
};

export interface FileIconProps {
  type: FileType | EntityType;
  className?: string;
  style?: React.CSSProperties;
}

export const FileIcon: React.FC<FileIconProps> = ({ type, className = "", style }) => {
  const FileIcon = formFileIconsHash[type];

  return FileIcon ? (
    <FileIcon style={{ ...style, minWidth: "24px", width: "24px" }} className={className} />
  ) : (
    <OtherTypeIcon style={{ ...style, minWidth: "24px", width: "24px" }} className={className} />
  );
};
